export class AuthRequiredError extends Error {
	constructor(path) {
		// Pass remaining arguments (including vendor specific ones) to parent constructor
		const message = `Sie werden authentifiziert ...`;
		super(message);

		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, AuthRequiredError);
		}
		this.redirect = path;
		this.name = "AuthRequiredError";
	}
}
